import '../scss/style.scss';
import { main as mainCookies } from "./modules/cookies.js";

document.addEventListener('DOMContentLoaded', () => {
	// Activate sticky header after the hero (first block) scrolls out of view
	const stickyHeader = document.querySelector('.wp-block-template-part.is-sticky');
	if ( stickyHeader ) {
		const hero = document.querySelector( '.entry-content.wp-block-post-content > *:first-child' );
		if ( hero ) {
			const observer = new IntersectionObserver( ( [ entry ] ) => {
				stickyHeader.classList.toggle( 'is-sticky-active', ! entry.isIntersecting );
			}, { threshold: 0 } );
			observer.observe( hero );
		}
	}
	mainCookies();
	const animated = [
		'.wp-block-reqst-text-image',
		'.wp-block-reqst-hero',
		'.wp-block-reqst-fees',
		'.wp-block-reqst-content-list',
		'.wp-block-reqst-image-sections',
		'.wp-block-reqst-accordeon',
		'.wp-block-reqst-carousel',
		'.wp-block-reqst-reviews',
	]
	const observer = new IntersectionObserver( ( entries ) => {
		entries.forEach( ( entry ) => {
			if (entry.isIntersecting) {
				entry.target.classList.add( 'intersecting' );
			}
		} );
	}, { threshold: 0 } );
	document.querySelectorAll(animated.join(', ')).forEach((block) => {
		block.classList.add('animated');
		observer.observe(block);
	});
});
